module.exports = __webpack_public_path__ + "img/feature3.3bc6c558.svg";